import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";
import { phOptIn } from "@/lib/posthog";

const STORAGE_KEY = "cookie-consent-v1";

const CookieConsentBanner = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored !== "accepted" && stored !== "declined") {
        setVisible(true);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch (e) {}
    if (typeof window !== "undefined" && typeof (window as any).gtag === "function") {
      (window as any).gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        personalization_storage: "granted",
      });
    }
    // Start PostHog capturing and let any consent-gated listeners (e.g. the A/B
    // exposure event) fire now that consent is granted.
    phOptIn();
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("analytics-consent-granted"));
    }
    setVisible(false);
  };

  const handleDecline = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "declined");
    } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  const isEs = language === "es";
  const body = isEs
    ? "Usamos cookies para entender cómo se usa el sitio. Puedes aceptar o rechazar el rastreo analítico."
    : "We use cookies to understand how visitors use the site. You can accept or decline analytics tracking.";
  const acceptLabel = isEs ? "Aceptar" : "Accept";
  const declineLabel = isEs ? "Rechazar" : "Decline";

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={isEs ? "Aviso de cookies" : "Cookie notice"}
      className="fixed bottom-4 right-4 left-4 sm:left-auto max-w-sm rounded-lg shadow-lg bg-card border p-4 z-40"
    >
      <p className="text-sm text-card-foreground mb-3">{body}</p>
      <div className="flex gap-3 justify-end">
        <Button variant="outline" onClick={handleDecline}>
          {declineLabel}
        </Button>
        <Button onClick={handleAccept}>
          {acceptLabel}
        </Button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
